import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useLogsStore = defineStore('logs', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    const logs          = ref({})
    const logsProcess   = ref(false)
    const logsMsg       = ref('')

    async function readLogs(payload) {

        logsProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/logs${params}`, 
                method: 'GET', 
                token
            })

            if(!request.error) {

                request.array.map(log => {
                    if(log.details) {
                        let detailsArray = log.details.split('; '),
                            detailsObjectsArray = {}
                        detailsArray.map(detail => {
                            const detailArray = detail.split('=')
                            if(detailArray.length == 2) detailsObjectsArray[detailArray[0]] =  detailArray[1]
                        })
                        log.details = detailsObjectsArray
                    }
                })

                logs.value = request
                logsMsg.value = { success: true, text: '' }

            } else {
                logs.value = {}
                logsMsg.value = { success: false, text: request.error }
            }

        } else {

            logsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        logsProcess.value = false
        return logs.value
    }

    const clearLogs = () => { 

        logs.value = { array: [] }
        logsMsg.value = null
    }

    return {

        configStore,
        requestsStore,
        tokenStore,
        logs,
        logsProcess,
        logsMsg,
        readLogs,
        clearLogs
    }
})
